import React, { useContext, useEffect, useState } from "react";
import { Form, Button, Radio, Select, InputNumber } from "antd";
import InfoContext, { AppContext } from "../../context";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
import { RiBusFill, RiCloseCircleLine, RiWalkFill } from "react-icons/ri";
import AHPButtonOptions from "../ButtonOptions/AHPButtonOptions";
import {
  FaCarSide,
  FaMotorcycle,
  FaTruck,
  FaTruckMoving,
} from "react-icons/fa";
import { IoIosAirplane, IoMdTrain } from "react-icons/io";
import { GrBike } from "react-icons/gr";
import { useHistory } from "react-router-dom";

export class Inquiry {
  constructor(routes, total, id) {
    this.cfp_routes = routes;
    this.cfp_total = total;
    this.client_id = id;
  }
}

const transportationCarbonFootprint = {
  car: {
    diesel: 0.000179,
    gasoline: 0.000184,
    gpl: 0.00021,
    electric: 0,
  },
  light_truck: {
    diesel: 0.000197,
    gasoline: 0.000196,
    gpl: 0.000219,
  },
  heavy_truck: {
    diesel: 0.000343,
  },
  bus: {
    diesel: 0.000343,
  },
  plane: {
    jetfuel: 0.000357,
  },
  motorcycle: {
    gasoline: 0.000167,
  },
  train: {},
  bike: {},
  walk: {},
};

const passengersInfo = {
  car: { default: 2, min: 1, max: 10, icon: <FaCarSide /> },
  light_truck: { default: 2, min: 1, max: 6, icon: <FaTruck /> },
  heavy_truck: { default: 2, min: 1, max: 6, icon: <FaTruckMoving /> },
  bus: { default: 30, min: 1, max: 80, icon: <RiBusFill /> },
  plane: { default: 100, min: 10, max: 300, icon: <IoIosAirplane /> },
  motorcycle: { default: 2, min: 1, max: 3, icon: <FaMotorcycle /> },
  train: { default: 100, min: 1, max: 300, icon: <IoMdTrain /> },
  bike: { default: 1, min: 1, max: 3, icon: <GrBike /> },
  walk: { default: 1, min: 1, max: 50, icon: <RiWalkFill /> },
};

const CarbonFootprintInquiry = ({ setInquiry }) => {
  const info = useContext(AppContext);

  const [transportation, setTransportation] = useState(null);
  const [distance, setDistance] = useState(0);
  const [fuel, setFuel] = useState(null);
  const [routes, setRoutes] = useState([]);
  const [passengers, setPassengers] = useState(1);
  const [units, setUnits] = useState("km");
  const [total, setTotal] = useState(0);

  let history = useHistory();

  useEffect(() => {
    setTotal(routes.reduce((a, c) => a + c.carbonFootprint, 0));
  }, [routes]);

  const addTrack = () => {
    // if there's no fuel, carbon footprint is zero
    const carbonFootprint =
      Math.round(
        (transportationCarbonFootprint[transportation][fuel]
          ? distance *
            (1 / passengers) *
            transportationCarbonFootprint[transportation][fuel] *
            (units === "km" ? 1000 : 1609.34)
          : 0) * 100
      ) / 100;
    setRoutes([
      ...routes,
      {
        mean: transportation,
        passengers,
        fuel,
        distance,
        units,
        carbonFootprint,
      },
    ]);
  };

  console.log(
    `transportation keys`,
    Object.keys(transportationCarbonFootprint).map((mean) => mean)
  );

  // sync transportation with passenger number and fuel
  useEffect(() => {
    if (transportation) {
      // if has fuel, set first option
      setFuel(
        Object.keys(transportationCarbonFootprint[transportation]).length > 0
          ? Object.keys(transportationCarbonFootprint[transportation])[0]
          : info.t("noFuel")
      );
      setPassengers(passengersInfo[transportation].default);
    }
  }, [transportation]);

  return (
    <InfoContext>
      <div
        style={{
          width: "100%",
          position: "relative",
          marginTop: -20,
          overflow: "clip",
        }}
      >
        <img
          src="https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/01/o-que-fazer-2.jpg"
          alt="aldeias green pastures"
          width="130%"
        />
        <h1 style={{ position: "absolute", top: 10, left: 20 }}>
          {info.t("ecologicalFootprint")}
        </h1>
        <div
          style={{
            position: "absolute",
            top: 70,
            left: 20,
            textAlign: "left",
            backgroundColor: "white",
            opacity: 0.8,
            color: "black",
            padding: 10,
            width: "80%",
          }}
        >
          {info.t("ecologicalFootprintText")}
        </div>
      </div>
      <div style={{ padding: "0px 30px 5px 30px" }}>
        <div
          style={{
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <AHPButtonOptions
            options={Object.keys(transportationCarbonFootprint).map((t) => ({
              name: t,
              icon: passengersInfo[t].icon,
            }))}
            setSelectedService={setTransportation}
            width={186}
          />
        </div>

        <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 12,
          }}
          layout="horizontal"
          style={{ marginTop: 20 }}
        >
          {/* <Form.Item label={info.t("transportation")}>
            <Select
              style={{ width: FIELD_WIDTHS.L }}
              onChange={(value) => {
                setTransportation(value);
              }}
              bordered={false}
              allowClear
            >
              {transportationCarbonFootprint &&
                Object.keys(transportationCarbonFootprint).length > 0 &&
                Object.keys(transportationCarbonFootprint).map((mean) => (
                  <Select.Option value={mean} key={mean}>
                    {info.t(mean)}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item> */}

          <Form.Item label={info.t("passengers")}>
            <InputNumber
              min={passengersInfo[transportation]?.min || 1}
              max={passengersInfo[transportation]?.max || 10}
              onChange={setPassengers}
              value={passengers}
            />
          </Form.Item>

          <Form.Item label={info.t("fuel")}>
            <Select
              onChange={setFuel}
              value={fuel}
              placeholder=""
              allowClear
              bordered={false}
              style={{ width: FIELD_WIDTHS.L }}
              disabled={
                !(
                  transportationCarbonFootprint[transportation] &&
                  Object.keys(transportationCarbonFootprint[transportation])
                    ?.length > 0
                )
              }
            >
              {transportation &&
                Object.keys(transportationCarbonFootprint[transportation]).map(
                  (fuel) => (
                    <Select.Option value={fuel} key={fuel}>
                      {info.t(fuel)}
                    </Select.Option>
                  )
                )}
            </Select>
          </Form.Item>

          <Form.Item label={info.t("distance")}>
            <InputNumber min={1} max={10000} onChange={setDistance} />
            <Radio.Group
              onChange={(e) => setUnits(e.target.value)}
              value={units}
              style={{ marginLeft: 20 }}
            >
              <Radio value="km">Km</Radio>
              <Radio value="miles">Miles</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item>
            <Button
              onClick={() => addTrack()}
              disabled={
                !transportation ||
                (transportation &&
                  Object.keys(transportationCarbonFootprint[transportation])
                    .length > 0 &&
                  !fuel) ||
                !distance
              }
            >
              {info.t("addRoute")}
            </Button>
          </Form.Item>
        </Form>

        {routes.length > 0 && (
          <div style={{ margin: 20 }}>
            <table>
              <thead>
                <th>{info.t("transportation")}</th>
                <th>{info.t("passengers")}</th>
                <th>{info.t("fuel")}</th>
                <th>{info.t("distance")}</th>
                <th>{info.t("carbonFootprint")}</th>
                <th></th>
              </thead>
              <tbody>
                {routes.length > 0 &&
                  routes.map((t, index) => (
                    <tr>
                      <td style={{ textAlign: "center", width: 100 }}>
                        {info.t(t.mean)}
                      </td>
                      <td style={{ textAlign: "center", width: 100 }}>
                        {t.passengers}
                      </td>
                      <td style={{ textAlign: "center", width: 100 }}>
                        {info.t(t.fuel)}
                      </td>
                      <td style={{ textAlign: "center", width: 100 }}>
                        {t.distance} {t.units}
                      </td>
                      <td style={{ textAlign: "center", width: 160 }}>
                        {t.carbonFootprint}
                      </td>
                      <td style={{ textAlign: "center", width: 100 }}>
                        {" "}
                        <RiCloseCircleLine
                          onClick={() =>
                            setRoutes(routes.filter((el, ind) => ind !== index))
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </td>
                    </tr>
                  ))}
                <tr></tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td
                    style={{
                      textAlign: "right",
                      width: 100,
                      backgroundColor: "lightgrey",
                    }}
                  >
                    <strong>{info.t("total")}</strong>
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      width: 100,
                      backgroundColor: "lightgrey",
                    }}
                  >
                    {Math.round(total * 100) / 100}
                  </td>
                </tr>
              </tbody>
            </table>
            <Button
              onClick={() => {
                const inquiry = new Inquiry(routes, total, info?.user?.id);
                setInquiry(inquiry);
                // history.push(
                //   info.language !== "pt"
                //     ? info.language + "/reservas?tab=3"
                //     : "/reservas?tab=3"
                // );
              }}
            >
              {info.t("submit")}
            </Button>
          </div>
        )}
      </div>
    </InfoContext>
  );
};

export default CarbonFootprintInquiry;
